import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSelectedReportsProfile } from "../../../store/reports/reports.selectors";
import { getDrilldownReportsPeriod } from "../drilldown.selectors";
import { isMultipleUserLevel } from "../../../store/account";
import { chartProps } from "../drilldown.constants";
import { DrilldownRoutePage } from "../drilldown.types";
import {
  changeProfile,
  cancelZoom,
  changePeriod,
} from "../../../store/reports/reports.actions";
import { DrilldownProfileSelect } from "./drilldownProfileSelect";
import { DrilldownTimePeriod } from "./drilldownTimePeriod";
import { ChartSliceInfo } from "./chartSliceInfo";
import { ReportsPeriod } from "../../../helpers/reports.helper.types";
import { DrilldownBarchart } from "./drilldownBarchart/DrilldownBarchart";
import { loadBarChartReport } from "../../../store/reports/reducers/barchart/barchart.actions";

interface DrilldownChartProps {
  page: DrilldownRoutePage;
}

export const DrilldownChart = ({ page }: DrilldownChartProps) => {
  const dispatch = useDispatch();

  const isMultiple = useSelector(isMultipleUserLevel);
  const profile = useSelector(getSelectedReportsProfile);
  const period = useSelector(getDrilldownReportsPeriod);
  const fetchBarChartReport = useCallback(() => {
    const { chartDataEndpoint } = chartProps[page];

    dispatch(
      loadBarChartReport([chartDataEndpoint], {
        period,
        profile,
      })
    );
  }, [dispatch, profile, period, page]);

  useEffect(() => {
    fetchBarChartReport();
  }, [fetchBarChartReport]);

  const resetTimeRange = (): void => {
    dispatch(cancelZoom());
  };

  const handleProfileChange = (profile: string): void => {
    dispatch(changeProfile(profile));
  };

  const handleReportPeriodChange = (period: ReportsPeriod): void => {
    dispatch(changePeriod(period));
  };

  const showProfiles: boolean =
    page !== DrilldownRoutePage.Botnet && isMultiple;

  return (
    <div className="reports-wrapper drilldowns__chart">
      <DrilldownTimePeriod
        period={period}
        onTimePeriodChange={handleReportPeriodChange}
      />
      {showProfiles && (
        <DrilldownProfileSelect onProfileChange={handleProfileChange} />
      )}
      <DrilldownBarchart page={page} onRefreshClick={fetchBarChartReport} />
      <ChartSliceInfo onCancelZoom={resetTimeRange} period={period} />
    </div>
  );
};
